/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateHealthcareFacilityDto
 */
export interface CreateUpdateHealthcareFacilityDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    nameDoctor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    namePsychological?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    displayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    nip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    nipPsychological?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    regon?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    regonPsychological?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    entryContentPsychological?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    entryContentDoctor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    p1WorkplaceOidExt?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    active?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    main?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    online?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    dutyId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    openMondayTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    closeMondayTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    openTuesdayTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    closeTuesdayTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    openWednesdayTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    closeWednesdayTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    openThursdayTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    closeThursdayTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    openFridayTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    closeFridayTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    openSaturdayTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    closeSaturdayTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    openSundayTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    closeSundayTime?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    validFrom?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    healthCareFacilityDataId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    createNewHealthcareFacilityData?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    symbolDoctor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHealthcareFacilityDto
     */
    symbolPsychological?: string | null;
}

/**
 * Check if a given object implements the CreateUpdateHealthcareFacilityDto interface.
 */
export function instanceOfCreateUpdateHealthcareFacilityDto(value: object): value is CreateUpdateHealthcareFacilityDto {
    return true;
}

export function CreateUpdateHealthcareFacilityDtoFromJSON(json: any): CreateUpdateHealthcareFacilityDto {
    return CreateUpdateHealthcareFacilityDtoFromJSONTyped(json, false);
}

export function CreateUpdateHealthcareFacilityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateHealthcareFacilityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'nameDoctor': json['nameDoctor'] == null ? undefined : json['nameDoctor'],
        'namePsychological': json['namePsychological'] == null ? undefined : json['namePsychological'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'city': json['city'] == null ? undefined : json['city'],
        'address': json['address'] == null ? undefined : json['address'],
        'nip': json['nip'] == null ? undefined : json['nip'],
        'nipPsychological': json['nipPsychological'] == null ? undefined : json['nipPsychological'],
        'regon': json['regon'] == null ? undefined : json['regon'],
        'regonPsychological': json['regonPsychological'] == null ? undefined : json['regonPsychological'],
        'entryContentPsychological': json['entryContentPsychological'] == null ? undefined : json['entryContentPsychological'],
        'entryContentDoctor': json['entryContentDoctor'] == null ? undefined : json['entryContentDoctor'],
        'p1WorkplaceOidExt': json['p1WorkplaceOidExt'] == null ? undefined : json['p1WorkplaceOidExt'],
        'active': json['active'] == null ? undefined : json['active'],
        'main': json['main'] == null ? undefined : json['main'],
        'online': json['online'] == null ? undefined : json['online'],
        'dutyId': json['dutyId'] == null ? undefined : json['dutyId'],
        'openMondayTime': json['openMondayTime'] == null ? undefined : json['openMondayTime'],
        'closeMondayTime': json['closeMondayTime'] == null ? undefined : json['closeMondayTime'],
        'openTuesdayTime': json['openTuesdayTime'] == null ? undefined : json['openTuesdayTime'],
        'closeTuesdayTime': json['closeTuesdayTime'] == null ? undefined : json['closeTuesdayTime'],
        'openWednesdayTime': json['openWednesdayTime'] == null ? undefined : json['openWednesdayTime'],
        'closeWednesdayTime': json['closeWednesdayTime'] == null ? undefined : json['closeWednesdayTime'],
        'openThursdayTime': json['openThursdayTime'] == null ? undefined : json['openThursdayTime'],
        'closeThursdayTime': json['closeThursdayTime'] == null ? undefined : json['closeThursdayTime'],
        'openFridayTime': json['openFridayTime'] == null ? undefined : json['openFridayTime'],
        'closeFridayTime': json['closeFridayTime'] == null ? undefined : json['closeFridayTime'],
        'openSaturdayTime': json['openSaturdayTime'] == null ? undefined : json['openSaturdayTime'],
        'closeSaturdayTime': json['closeSaturdayTime'] == null ? undefined : json['closeSaturdayTime'],
        'openSundayTime': json['openSundayTime'] == null ? undefined : json['openSundayTime'],
        'closeSundayTime': json['closeSundayTime'] == null ? undefined : json['closeSundayTime'],
        'validFrom': json['validFrom'] == null ? undefined : (new Date(json['validFrom'])),
        'healthCareFacilityDataId': json['healthCareFacilityDataId'] == null ? undefined : json['healthCareFacilityDataId'],
        'createNewHealthcareFacilityData': json['createNewHealthcareFacilityData'] == null ? undefined : json['createNewHealthcareFacilityData'],
        'symbolDoctor': json['symbolDoctor'] == null ? undefined : json['symbolDoctor'],
        'symbolPsychological': json['symbolPsychological'] == null ? undefined : json['symbolPsychological'],
    };
}

export function CreateUpdateHealthcareFacilityDtoToJSON(value?: CreateUpdateHealthcareFacilityDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nameDoctor': value['nameDoctor'],
        'namePsychological': value['namePsychological'],
        'displayName': value['displayName'],
        'city': value['city'],
        'address': value['address'],
        'nip': value['nip'],
        'nipPsychological': value['nipPsychological'],
        'regon': value['regon'],
        'regonPsychological': value['regonPsychological'],
        'entryContentPsychological': value['entryContentPsychological'],
        'entryContentDoctor': value['entryContentDoctor'],
        'p1WorkplaceOidExt': value['p1WorkplaceOidExt'],
        'active': value['active'],
        'main': value['main'],
        'online': value['online'],
        'dutyId': value['dutyId'],
        'openMondayTime': value['openMondayTime'],
        'closeMondayTime': value['closeMondayTime'],
        'openTuesdayTime': value['openTuesdayTime'],
        'closeTuesdayTime': value['closeTuesdayTime'],
        'openWednesdayTime': value['openWednesdayTime'],
        'closeWednesdayTime': value['closeWednesdayTime'],
        'openThursdayTime': value['openThursdayTime'],
        'closeThursdayTime': value['closeThursdayTime'],
        'openFridayTime': value['openFridayTime'],
        'closeFridayTime': value['closeFridayTime'],
        'openSaturdayTime': value['openSaturdayTime'],
        'closeSaturdayTime': value['closeSaturdayTime'],
        'openSundayTime': value['openSundayTime'],
        'closeSundayTime': value['closeSundayTime'],
        'validFrom': value['validFrom'] == null ? undefined : ((value['validFrom'] as any).toISOString()),
        'healthCareFacilityDataId': value['healthCareFacilityDataId'],
        'createNewHealthcareFacilityData': value['createNewHealthcareFacilityData'],
        'symbolDoctor': value['symbolDoctor'],
        'symbolPsychological': value['symbolPsychological'],
    };
}

